import {getQueryParams} from '@wix/music-shared/dist/src/utils/queryParams/queryParams';

export function getAlbumAndTrackId(search: string, hashParams: string) {
  hashParams = hashParams.split('?')[1] || '';
  const {albumId, trackId: trackIdStr} = {...getQueryParams(), ...getQueryParams(hashParams)} as any;
  const trackId = trackIdStr ? parseInt(trackIdStr, 10) : undefined;
  return {albumId, trackId};
}
